import { FETCH_LIVE, ADD_ACTION, DELETE_ACTION, EDIT_ACTION, SCORE, END_LIVE, RESET_DEMO } from '../constants';
import axios from 'axios';
import { API_HOST } from '../config.env';
import _ from 'lodash';
import getDemoData from '../fixtures/demos';
import moment from 'moment';

const headers = access => ({
    headers: {
        Accept: 'application/ld+json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`
    }
});

export const fetchLive = (id, access) => {
    return dispatch => {
        const caches = localStorage.getItem(`/api/lives/${id}`);
        if(caches && (moment().unix() - JSON.parse(caches).cache_ttl_expires_at) < 0) {
            const promise = new Promise((resolve, reject) => resolve());
            return promise.then(() => {
                dispatch({
                    type: FETCH_LIVE,
                    payload: {
                        key: `/api/lives/${id}`,
                        live: JSON.parse(caches),
                        match: JSON.parse(caches).match
                    }
                });
            })
        }
        else {
            if(id === 'demo') {
                const demos = getDemoData();
                localStorage.setItem(`/api/lives/${id}`, JSON.stringify(demos));
                const promise = new Promise((resolve, reject) => resolve());
                return promise.then(() => {
                    dispatch({
                        type: FETCH_LIVE,
                        payload: {
                            key: `/api/lives/${id}`,
                            live: demos,
                            match: demos.match
                        }
                    });
                })
            }

            return axios.get(`${API_HOST}/api/lives/${id}`, headers(access)).then(response => {
                if(response.status === 200) {
                   return axios.get(`${API_HOST}/api/matches/${response.data.matchId}`, headers(access)).then(r => {
                        if(r.status === 200){
                            dispatch({
                                type: FETCH_LIVE,
                                payload: {
                                    key: `/api/lives/${id}`,
                                    live: response.data,
                                    match: r.data
                                }
                            });
                            const live = _.assignIn(response.data, {match: r.data, cache_ttl_expires_at: moment().add(1, 'week').unix()});
                            localStorage.setItem(`/api/lives/${id}`, JSON.stringify(live));
                        }
                    })
                }
            });
        }
    }
}

export const addActionLive = (id, live) => ({type: ADD_ACTION, payload: {id, live}});

export const editActionLive = (id, live) => ({type: EDIT_ACTION, payload: {id, live}});

export const deleteActionLive = (id, action) => ({type: DELETE_ACTION, payload: {id, action}});

export const score = (id, score) => ({type: SCORE, payload: {id, score}});

export const endLive = id => ({type: END_LIVE, payload: {id}});

export const resetDemo = () => ({type: RESET_DEMO});

